import { useFilteredInfringements } from "@/hooks/useFilteredInfringements";
import { WidgetShell } from "@/components/dashboard/WidgetShell";

export function KpiSummaryWidget() {
  const { infringements, isPending, totalCount, isFiltered } = useFilteredInfringements();

  const total = infringements.length;
  const blocked = infringements.filter((i) => i.action_result === "blocked").length;
  const ignored = infringements.filter((i) => i.action_result === "ignored").length;
  const unactioned = infringements.filter(
    (i) => i.action_result !== "blocked" && i.action_result !== "ignored",
  ).length;

  const dash = isPending ? "—" : undefined;

  return (
    <WidgetShell
      title="Total Infringements"
      action={
        isFiltered && !isPending ? (
          <span className="text-xs text-muted">({totalCount} total)</span>
        ) : undefined
      }
    >
      <div className="flex-1 flex flex-col px-4 py-4 justify-between">
        {/* Big total */}
        <span className="text-6xl font-bold tabular-nums text-primary leading-none">
          {dash ?? total}
        </span>

        {/* Sub-metrics */}
        <div className="flex items-end gap-8">
          <div className="flex flex-col gap-1">
            <span className={`text-sm font-light ${blocked > 0 ? "text-rose-500 dark:text-rose-300" : "text-primary"}`}>Blocked</span>
            <span
              className={`text-3xl font-semibold tabular-nums leading-none ${
                blocked > 0 ? "text-rose-500 dark:text-rose-300" : "text-primary"
              }`}
            >
              {dash ?? blocked}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-sm font-light text-primary">Ignored</span>
            <span className="text-3xl font-semibold tabular-nums leading-none text-primary">
              {dash ?? ignored}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-sm font-light text-primary">Unactioned</span>
            <span className="text-3xl font-semibold tabular-nums leading-none text-primary">
              {dash ?? unactioned}
            </span>
          </div>
        </div>
      </div>
    </WidgetShell>
  );
}
